<template>
    <el-container style="height: 100%">
        <el-main style="height: 100%">
            <!-- 筛选区 -->
            <el-row style="margin-bottom: 10px">
                <el-col :span="12">
                    <el-input v-model="query.keyword" placeholder="搜索内容" clearable @keyup.enter="loadList">
                        <template #append>
                            <el-button @click="loadList"><el-icon><Search /></el-icon></el-button>
                        </template>
                    </el-input>
                </el-col>
                <el-col :span="12" style="text-align: right">
                    <el-select v-model="query.type" placeholder="全部样式" clearable style="width: 140px" @change="loadList">
                        <el-option v-for="t in types" :key="t.value" :label="t.label" :value="t.value" />
                    </el-select>
                </el-col>
            </el-row>

            <!-- 卡片墙 -->
            <el-row :gutter="12">
                <el-col :xs="24" :sm="12" :md="8" :lg="4" v-for="item in list" :key="item.id" style="margin-bottom: 12px">
                    <WhiteBoardCard :item="item" @like="handleLike" @view="handleView" />
                </el-col>
            </el-row>
            <el-empty v-if="list.length === 0" description="还没有内容，快来发布第一条吧" />

            <!-- 分页 -->
            <div style="text-align: center; margin-top: 16px">
                <el-pagination
                    layout="prev, pager, next, total"
                    :total="total"
                    :page-size="query.pageSize"
                    :current-page="query.pageNum"
                    @current-change="handlePageChange"
                />
            </div>

            <!-- 右下角悬浮发布按钮 -->
            <el-button type="primary" circle class="wb-fab" @click="dialogVisible = true">
                <el-icon size="24"><Plus /></el-icon>
            </el-button>

            <!-- 录入弹框 -->
            <el-dialog v-model="dialogVisible" title="发布到白板" width="480px">
                <el-form>
                    <el-form-item label="昵称">
                        <el-input v-model="form.nickname" placeholder="匿名" maxlength="50" />
                    </el-form-item>
                    <el-form-item label="样式">
                        <el-select v-model="form.type" style="width: 100%">
                            <el-option v-for="t in types" :key="t.value" :label="t.label" :value="t.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="内容">
                        <el-input v-model="form.content" type="textarea" :rows="5" maxlength="10000" show-word-limit placeholder="写点什么..." />
                    </el-form-item>
                </el-form>
                <template #footer>
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submit">发布</el-button>
                </template>
            </el-dialog>

            <!-- 详情弹框 -->
            <el-dialog v-model="detailVisible" :title="detailItem.nickname ? detailItem.nickname + ' 的卡片' : '卡片详情'" width="1000px">
                <div class="detail-content" :class="{ 'detail-code': detailItem.type === 'code' }">{{ detailItem.content }}</div>
                <div class="detail-meta">
                    <span>样式：{{ typeLabel(detailItem.type) }}</span>
                    <span>发布：{{ detailItem.createTime }}</span>
                    <span>点赞：{{ detailItem.likeCount || 0 }}</span>
                </div>
                <template #footer>
                    <el-button type="danger" v-if="isLogin" @click="handleDelete">删除</el-button>
                    <el-button @click="detailVisible = false">关闭</el-button>
                </template>
            </el-dialog>
        </el-main>
    </el-container>
</template>

<script>
import { Search, Plus } from '@element-plus/icons';
import { ElMessage } from 'element-plus';
import { createCard, listCard, likeCard, deleteCard } from '@/api/whiteboard';
import WhiteBoardCard from './components/WhiteBoardCard.vue';

export default {
    components: { Search, WhiteBoardCard },
    data() {
        return {
            dialogVisible: false,
            detailVisible: false,
            detailItem: {},
            isLogin: false,
            types: [
                { label: '普通文本', value: 'text' },
                { label: '便签', value: 'sticky' },
                { label: '引用', value: 'quote' },
                { label: '代码块', value: 'code' },
                { label: '渐变', value: 'gradient' },
                { label: '公告', value: 'notice' }
            ],
            form: { nickname: '', type: 'text', content: '' },
            query: { keyword: '', type: '', pageNum: 1, pageSize: 20 },
            list: [],
            total: 0
        };
    },
    mounted() {
        document.title = 'Hidoc-白板';
        this.isLogin = !!(this.$store.state.user && this.$store.state.user.token);
        this.loadList();
    },
    methods: {
        buildExtra(type) {
            switch (type) {
                case 'sticky': {
                    const colors = ['#ffd166', '#ff8fa3', '#90e0ef', '#95d5b2'];
                    return { color: colors[Math.floor(Math.random() * colors.length)] };
                }
                case 'gradient': {
                    const grads = [
                        'linear-gradient(135deg,#667eea 0%,#764ba2 100%)',
                        'linear-gradient(135deg,#f093fb 0%,#f5576c 100%)',
                        'linear-gradient(135deg,#4facfe 0%,#00f2fe 100%)'
                    ];
                    return { gradient: grads[Math.floor(Math.random() * grads.length)] };
                }
                default:
                    return {};
            }
        },
        submit() {
            if (!this.form.content.trim()) {
                ElMessage({ message: '内容不能为空', type: 'warning' });
                return;
            }
            createCard({
                content: this.form.content,
                type: this.form.type,
                nickname: this.form.nickname,
                extra: JSON.stringify(this.buildExtra(this.form.type))
            }).then(res => {
                if (res.code === 0) {
                    ElMessage({ message: '发布成功', type: 'success' });
                    this.dialogVisible = false;
                    this.form.content = '';
                    this.query.pageNum = 1;
                    this.loadList();
                }
            });
        },
        loadList() {
            listCard(this.query).then(res => {
                if (res.code === 0) {
                    this.list = res.data || [];
                    this.total = res.total || 0;
                }
            });
        },
        handleLike(item) {
            likeCard({ id: item.id }).then(res => {
                if (res.code === 0 && res.meta.flag) {
                    item.likeCount = (item.likeCount || 0) + 1;
                }
            });
        },
        handleView(item) {
            this.detailItem = item;
            this.detailVisible = true;
        },
        handleDelete() {
            deleteCard({ id: this.detailItem.id }).then(res => {
                if (res.code === 0) {
                    ElMessage({ message: '删除成功', type: 'success' });
                    this.detailVisible = false;
                    this.loadList();
                }
            });
        },
        typeLabel(type) {
            const t = this.types.find(x => x.value === type);
            return t ? t.label : type;
        },
        handlePageChange(page) {
            this.query.pageNum = page;
            this.loadList();
        }
    }
};
</script>

<style scoped>
.el-main {
    text-align: left;
}
.wb-fab {
    position: fixed;
    right: 32px;
    bottom: 32px;
    width: 56px;
    height: 56px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    z-index: 1000;
}
.detail-content {
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 60vh;
    overflow: auto;
    padding: 12px;
    background: #f7f9fc;
    border-radius: 6px;
}
.detail-code {
    font-family: Consolas, Monaco, 'Courier New', monospace;
    background: #1e1e1e;
    color: #d4d4d4;
}
.detail-meta {
    margin-top: 12px;
    display: flex;
    gap: 16px;
    font-size: 12px;
    color: #909399;
}
</style>
